"use client";
import * as React from "react";
import { useState, useEffect } from "react";

function FloatingNotesTimeline() {
  const [hoveredNote, setHoveredNote] = useState(null);

  const timelineData = [
    {
      id: 1,
      number: "01",
      title: "Business Analysis Consulting",
      content: `Vasta Business Analysis Consulting provides business needs and determining solutions to business problems. We use various techniques which includes: Brainstorming, Document analysis, Focus group, Interface analysis, Interviews, Requirement Workshops, Prototyping, Reverse Engineering, Surveys, User Task Analysis, Process mapping, Observation, Job Shadowing. We specialized on S.W.O.T. of each Projects to determine: Strengths, Weaknesses, Opportunities and Threats.`,
      color: "bg-blue-50",
      pinColor: "bg-blue-500",
      rotation: "rotate-2",
      position: "left"
    },
    {
      id: 2,
      number: "02",
      title: "Enterprise Business Process Management (BPM)",
      content: `Our Business Process Management (BPM) Services provides holistic management approach to its client's business processes. It works continuously to improve processes to strengthen our Stakeholder's Processes are efficient and effective, as this will result in a better and more cost efficient. Our BPM Software are having excellent components on Social, Process, Rules, Portal, Forms, Analytics, Mobile, Content, Collaboration, Data Access, SOA and Integration.`,
      color: "bg-indigo-50",
      pinColor: "bg-indigo-500",
      rotation: "-rotate-1",
      position: "right"
    },
    {
      id: 3,
      number: "03",
      title: "Corporate Change Management Consulting",
      content: `As they say: CHANGE IS THE UNCHANGEABLE LAW OF NATURE ………and we trust on this. Our Change management is an approach to transitioning individuals, teams, and organizations to a desired future state. Our Change Management provides facilities in a structured approach in an organization for ensuring that changes are smoothly and successfully implemented to achieve the final goal. Our objectives, content, and process of changes are our specified part of Change Management plan.`,
      color: "bg-purple-50",
      pinColor: "bg-purple-500",
      rotation: "rotate-3",
      position: "left"
    },
    {
      id: 4,
      number: "04",
      title: "Strategy Management Consulting",
      content: `Vasta Strategic Management has defined to set a target to determine mission, vision, values, goals, objectives, roles and responsibilities, timelines, etc. It consists of the analysis, decisions, and actions an organization undertakes in order to create and sustain competitive advantages. All our Strategic Management not static its always dynamic and changeable and Ongoing process.`,
      color: "bg-green-50",
      pinColor: "bg-green-500",
      rotation: "-rotate-2",
      position: "right"
    },
    {
      id: 5,
      number: "05",
      title: "Risk Management Implementation Consulting",
      content: `Vasta Risk Management Implementation Consulting Provides identification, assessment, and prioritization of risks which includes various method is in the terms of project management, security, engineering, industrial processes, financial portfolios, actuarial assessments, or public health and safety. Our Risk management always minimizes spending with minimizes the negative effects of risks. And we give more focus on resources spent on risk management could have been spent on more profitable activities.`,
      color: "bg-pink-50",
      pinColor: "bg-pink-500",
      rotation: "rotate-1",
      position: "left"
    },
    {
      id: 6,
      number: "06",
      title: "Pre-Sales Consulting",
      content: `Vasta Pre-Sales assists the sales process by working with Stakeholders and make sure that they understand the software and consulting services. We conduct the Pre-Sales demos and explains the project flows in sales presentations. Our Pre-Sales has both technical and business expertise, We know how our Stakeholder's products will be implemented in the market with all those business potential.`,
      color: "bg-yellow-50",
      pinColor: "bg-yellow-500",
      rotation: "-rotate-3",
      position: "right"
    }
  ];

  // Calculate positions for each card (desktop only)
  const getCardPosition = (index) => {
    const cardHeight = 380; // Approximate card height
    const threeQuarterCardHeight = (cardHeight * 3) / 4; // 3/4 of card height

    if (index === 0) {
      return 0; // First card starts at top
    }

    // Each subsequent card starts when previous card is 3/4 done
    return index * threeQuarterCardHeight;
  };

  const CurvedPath = ({ startX, startY, endX, endY, isReversed = false }) => {
    const midX = (startX + endX) / 2;
    const midY = (startY + endY) / 2;
    const controlX = isReversed ? midX - 120 : midX + 120;
    const controlY = midY - 50;

    return (
      <path
        d={`M ${startX} ${startY} Q ${controlX} ${controlY} ${endX} ${endY}`}
        stroke="#6366f1"
        strokeWidth="3"
        strokeDasharray="12,8"
        fill="none"
        className="opacity-60"
        strokeLinecap="round"
      />
    );
  };

  const PushPin = ({ color, className = "" }) => (
    <div className={`absolute -top-3 left-1/2 transform -translate-x-1/2 z-20 ${className}`}>
      <div className={`w-7 h-7 ${color} rounded-full shadow-lg border-3 border-white relative`}>
        <div className="absolute inset-1 bg-white bg-opacity-40 rounded-full"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2.5 h-2.5 bg-white bg-opacity-70 rounded-full"></div>
      </div>
      <div className="absolute top-7 left-1/2 transform -translate-x-1/2 w-1.5 h-2.5 bg-slate-400 rounded-b-sm shadow-sm"></div>
    </div>
  );

  const FloatingNote = ({ note, index, onHover, onLeave, isHovered }) => {
    const baseClasses = `
      relative bg-white rounded-2xl p-6 shadow-xl transform transition-all duration-500 ease-out
      ${note.rotation} hover:rotate-0 hover:scale-105 hover:-translate-y-3
      ${isHovered ? 'z-30 shadow-2xl scale-105' : 'z-10'}
      max-w-sm w-full border border-slate-100
    `;

    const floatingAnimation = {
      animation: `float-${index} 6s ease-in-out infinite`,
      animationDelay: `${index * 0.5}s`
    };

    return (
      <div
        className={baseClasses}
        style={floatingAnimation}
        onMouseEnter={() => onHover(note.id)}
        onMouseLeave={onLeave}
        role="article"
        aria-labelledby={`note-title-${note.id}`}
        tabIndex={0}
      >
        <PushPin color={note.pinColor} />

        <div className="pt-4">
          <div className="flex items-center gap-3 mb-4">
            <span className="text-2xl font-bold text-slate-800 font-mono">
              {note.number}
            </span>
          </div>

          <h3
            id={`note-title-${note.id}`}
            className="text-xl font-bold text-slate-900 mb-4 leading-tight"
          >
            {note.title}
          </h3>

          <div className={`${note.color} rounded-xl p-4 border border-slate-100`}>
            <p className="text-slate-700 text-sm leading-relaxed">
              {note.content}
            </p>
          </div>
        </div>

        <div className="absolute inset-0 bg-gradient-to-br from-white via-transparent to-slate-50 rounded-2xl pointer-events-none opacity-40"></div>
      </div>
    );
  };

  // Mobile Timeline Item Component
  const MobileTimelineItem = ({ note, index, onHover, onLeave, isHovered, showConnector }) => {
    return (
      <div className="relative mb-8">
        <div className="flex items-start gap-4">
          {/* Timeline dot */}
          <div className="flex-shrink-0 mt-6">
            <div className={`w-4 h-4 ${note.pinColor} rounded-full border-4 border-white shadow-lg`}></div>
          </div>

          {/* Card content */}
          <div
            className={`
              relative bg-white rounded-xl p-4 shadow-lg transform transition-all duration-300 ease-out
              hover:scale-105 hover:shadow-xl flex-1 border border-slate-100
              ${isHovered ? 'shadow-xl scale-105' : ''}
            `}
            onMouseEnter={() => onHover(note.id)}
            onMouseLeave={onLeave}
            role="article"
            aria-labelledby={`mobile-note-title-${note.id}`}
            tabIndex={0}
          >
            <div className="flex items-center gap-3 mb-3">
              <span className="text-lg font-bold text-slate-800 font-mono">
                {note.number}
              </span>
            </div>

            <h3
              id={`mobile-note-title-${note.id}`}
              className="text-lg font-bold text-slate-900 mb-3 leading-tight"
            >
              {note.title}
            </h3>

            <div className={`${note.color} rounded-lg p-3 border border-slate-100`}>
              <p className="text-slate-700 text-xs leading-relaxed">
                {note.content}
              </p>
            </div>
          </div>
        </div>

        {/* Connector line */}
        {showConnector && (
          <div className="absolute left-2 top-10 w-0.5 h-12 bg-gradient-to-b from-indigo-300 to-transparent"></div>
        )}
      </div>
    );
  };

  // Decorative Dots Component
  const DecorativeDots = ({ position, color = "blue" }) => {
    const dots = [];
    const baseSize = position === "top-right" ? 6 : 8;
    const dotCount = position === "top-right" ? 15 : 20;

    for (let i = 0; i < dotCount; i++) {
      const size = Math.max(2, baseSize - i * 0.3);
      const opacity = Math.max(0.1, 0.8 - i * 0.04);
      const offset = i * (position === "top-right" ? 12 : 15);

      dots.push(
        <div
          key={i}
          className={`absolute w-${Math.ceil(size/4)} h-${Math.ceil(size/4)} bg-${color}-400 rounded-full`}
          style={{
            width: `${size}px`,
            height: `${size}px`,
            opacity: opacity,
            ...(position === "top-right"
              ? { top: `${offset}px`, right: `${offset}px` }
              : { bottom: `${offset}px`, left: `${offset}px` }
            )
          }}
        />
      );
    }

    return <div className="absolute inset-0 pointer-events-none">{dots}</div>;
  };

  return (
    <>
      <style >{`
        @keyframes float-0 {
          0%, 100% { transform: translateY(0px) rotate(2deg); }
          50% { transform: translateY(-8px) rotate(2deg); }
        }
        @keyframes float-1 {
          0%, 100% { transform: translateY(0px) rotate(-1deg); }
          50% { transform: translateY(-12px) rotate(-1deg); }
        }
        @keyframes float-2 {
          0%, 100% { transform: translateY(0px) rotate(3deg); }
          50% { transform: translateY(-6px) rotate(3deg); }
        }
        @keyframes float-3 {
          0%, 100% { transform: translateY(0px) rotate(-2deg); }
          50% { transform: translateY(-10px) rotate(-2deg); }
        }
        @keyframes float-4 {
          0%, 100% { transform: translateY(0px) rotate(1deg); }
          50% { transform: translateY(-14px) rotate(1deg); }
        }
        @keyframes float-5 {
          0%, 100% { transform: translateY(0px) rotate(-3deg); }
          50% { transform: translateY(-7px) rotate(-3deg); }
        }

        .paper-texture {
          background-image:
            radial-gradient(circle at 1px 1px, rgba(99, 102, 241, 0.03) 1px, transparent 0);
          background-size: 20px 20px;
        }

        .board-shadow {
          box-shadow:
            0 25px 50px -12px rgba(99, 102, 241, 0.25),
            0 0 0 1px rgba(255, 255, 255, 0.05),
            inset 0 1px 0 rgba(255, 255, 255, 0.1);
        }
      `}</style>

      <section className="min-h-screen bg-gradient-to-br from-[#edf4ff] via-blue-50/30 to-indigo-50/40 relative overflow-hidden py-8 lg:py-16" aria-labelledby="timeline-heading">
        {/* Background decorative elements */}
        <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
          <div className="absolute top-1/4 left-1/4 w-72 h-72 lg:w-80 lg:h-80 md:w-60 md:h-60 sm:w-40 sm:h-40 bg-blue-200/20 rounded-full blur-3xl"></div>
          <div className="absolute bottom-1/4 right-1/4 w-72 h-72 lg:w-80 lg:h-80 md:w-60 md:h-60 sm:w-40 sm:h-40 bg-indigo-200/20 rounded-full blur-3xl"></div>
        </div>

        {/* Decorative cone-shaped dots */}
        <DecorativeDots position="top-right" color="blue" />
        <DecorativeDots position="bottom-left" color="indigo" />

        <div className="relative z-10 max-w-6xl mx-auto px-4 lg:px-8">
          {/* Header */}
          <header className="text-center mb-8 lg:mb-16">
            <div className="inline-flex items-center px-4 lg:px-6 py-2 bg-gradient-to-r from-indigo-600 to-blue-600 backdrop-blur-md border border-indigo-600/60 rounded-full mb-4 lg:mb-6 shadow-lg">
              <span className="w-2 h-2 bg-white rounded-full mr-3 animate-pulse"></span>
              <span className="text-xs lg:text-sm text-white font-semibold uppercase tracking-wider">
                Our Services Timeline
              </span>
            </div>
            <h1
              id="timeline-heading"
              className="text-3xl lg:text-5xl font-bold text-slate-900 leading-tight tracking-tight mb-4"
              style={{ fontFamily: 'Sora, system-ui, sans-serif' }}
            >
              Vasta Consulting
              <br />
              <span className="bg-gradient-to-r from-indigo-600 to-blue-600 bg-clip-text text-transparent">
                Service Journey
              </span>
            </h1>
            <p className="text-slate-600 mt-4 text-base lg:text-lg max-w-3xl mx-auto leading-relaxed px-4">
              A comprehensive timeline of our consulting services designed to transform your business operations and drive sustainable growth.
            </p>
          </header>

          {/* Desktop Timeline */}
          <div className="hidden lg:block relative">
            {/* SVG for curved connection paths */}
            <svg
              className="absolute inset-0 w-full h-full pointer-events-none z-0"
              aria-hidden="true"
              style={{ height: `${getCardPosition(timelineData.length - 1) + 400}px` }}
            >
              <defs>
                <filter id="pathGlow">
                  <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
                  <feMerge>
                    <feMergeNode in="coloredBlur"/>
                    <feMergeNode in="SourceGraphic"/>
                  </feMerge>
                </filter>
              </defs>

              {timelineData.slice(0, -1).map((note, index) => {
                const nextNote = timelineData[index + 1];

                // Calculate actual card positions for proper line connections
                const currentCardTop = getCardPosition(index);
                const nextCardTop = getCardPosition(index + 1);

                // Connection points at the center of each card
                const startX = note.position === 'left' ? 200 : 600;
                const startY = currentCardTop + 140; // Center of current card
                const endX = nextNote.position === 'left' ? 200 : 600;
                const endY = nextCardTop + 140; // Center of next card

                return (
                  <CurvedPath
                    key={`path-${index}`}
                    startX={startX}
                    startY={startY}
                    endX={endX}
                    endY={endY}
                    isReversed={note.position !== nextNote.position}
                  />
                );
              })}
            </svg>

            {/* Timeline notes with proper spacing */}
            <div className="relative z-10">
              {timelineData.map((note, index) => {
                const topPosition = getCardPosition(index);

                return (
                  <div
                    key={note.id}
                    className={`absolute ${note.position === 'left' ? 'left-8' : 'right-8'}`}
                    style={{
                      top: `${topPosition}px`,
                      zIndex: 10 + index // Ensure proper stacking
                    }}
                  >
                    <FloatingNote
                      note={note}
                      index={index}
                      onHover={setHoveredNote}
                      onLeave={() => setHoveredNote(null)}
                      isHovered={hoveredNote === note.id}
                    />
                  </div>
                );
              })}
            </div>

            {/* Add bottom spacing to accommodate all cards */}
            <div style={{ height: `${getCardPosition(timelineData.length - 1) + 350}px` }}></div>
          </div>

          {/* Mobile Timeline */}
          <div className="lg:hidden">
            <div className="max-w-lg mx-auto">
              {timelineData.map((note, index) => (
                <MobileTimelineItem
                  key={note.id}
                  note={note}
                  index={index}
                  onHover={setHoveredNote}
                  onLeave={() => setHoveredNote(null)}
                  isHovered={hoveredNote === note.id}
                  showConnector={index < timelineData.length - 1}
                />
              ))}
            </div>
          </div>

          {/* Decorative elements */}
          <div className="absolute top-8 right-8 w-4 h-4 bg-blue-400 rounded-full opacity-60"></div>
          <div className="absolute bottom-8 left-8 w-3 h-3 bg-indigo-400 rounded-full opacity-60"></div>
          <div className="absolute top-1/3 right-16 w-2 h-2 bg-purple-400 rounded-full opacity-60"></div>
        </div>
      </section>
    </>
  );
}

export default FloatingNotesTimeline;
